import { useState, useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

const ITEM_HEIGHT = 40;
const MENU_ITEM_HEIGHT = 44;

export default function VerticalHamburgerMenu(props) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [options, setOptions] = useState([]);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [pendingOption, setPendingOption] = useState(null);

    useEffect(() => {
      // keep only enabled options
      const activeOptions = props.options.filter(opt => !opt.disabled);
      setOptions(activeOptions);
    }, [props.options]);

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        if (options.length > 0) setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMenuItemClick = (option) => {
        if (option.confirmMessage) {
            setPendingOption(option);
            setConfirmOpen(true);
        } else {
            executeCallback(option);
        }
        handleClose();
    };

    const executeCallback = (option) => {
        if (props.params !== undefined) {
            option.callback(props.params);
        } else {
            option.callback();
        }
    };

    const handleConfirm = () => {
        if (pendingOption) {
            executeCallback(pendingOption);
        }
        setConfirmOpen(false);
        setPendingOption(null);
    };

    const handleCancel = () => {
        setConfirmOpen(false);
        setPendingOption(null);
        handleClose();
    };

    return (
        <div>
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
                edge="end"
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="long-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: 2, // theme spacing (8px if default)
                            height: MENU_ITEM_HEIGHT * options.length,
                            maxHeight: ITEM_HEIGHT * 4.5,
                            minWidth: 150,
                        },
                    },
                    list: {
                        'aria-labelledby': 'long-button',
                    },
                }}
            >
                {options.map((option) => (
                    <MenuItem
                        key={option.id}
                        onClick={() => handleMenuItemClick(option)}
                        sx={{
                            py: 1,
                        }}
                    >
                        {option.name}
                    </MenuItem>
                ))}
            </Menu>

            <Dialog open={confirmOpen} onClose={handleCancel} disableRestoreFocus>
                <DialogTitle>Confirm Action</DialogTitle>
                <DialogContent>
                    {pendingOption?.confirmMessage || 'Are you sure?'}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirm}>Confirm</Button>
                    <Button onClick={handleCancel}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}